export const LOCALES = {
  ENGLISH: "en",
  CHINESE: "zh-cn",
  MALAY: "ms",
  INDO: "id",
};
